import styled from 'styled-components'
import appModalTrigger from './appModalTrigger'
import { Link } from 'react-router-dom'

const StyledLink = styled(Link)`
  display: inline;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 5px 0;
  line-height: 16px;
  padding: 0;
  text-decoration: none;
  color: ${({ theme }) => theme.mainTextColor};

  &:hover {
    color: ${({ theme }) => theme.mainTextColor};
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }

  ${props => `
    ${props.theme.link.default};

    &:hover {
      ${props.theme.link.hover};
    }
    
    ${props.nolink && `
      text-decoration: none;
      font-size: 14px;
      
      &:hover {
        text-decoration: none;
      }
    `}

    ${props.css}
  `},
`

export default appModalTrigger(StyledLink)
